import Stack from "@mui/material/Stack/Stack";
import React from "react";
import Paper from "@mui/material/Paper";
import { Button, Fab, Input, TextField, Typography } from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SeparationState } from "../../store";
import { InventoryReservation } from "../../../../../../domain/models/inventory-reservation";
import { NormalizedCargoItem } from "../../../../../../domain/models/cargo-model";

export const SeparationPositionCollector: React.FC = () => {
  const navigate = useNavigate();
  const [code, setCode] = React.useState<string>("");

  const item = useSelector<SeparationState, NormalizedCargoItem | null>(
    (state) => state.currentItem!.item
  );

  const reservation = useSelector<SeparationState, InventoryReservation | null>(
    (state) => state.currentItem!.reservation
  );

  const handleClick = async () => {
    if (!code) {
      return alert("Insira o código da posição antes de continuar.");
    }
    if (!item) {
      alert("Erro. Reinicie o processo.");
      navigate("/mobile/separation");
    }

    if (code !== reservation?.inventory.position.code) {
      return alert("O código digitado não corresponde ao código da posição");
    }
    navigate("/mobile/separation/product-collector");
  };

  return (
    <>
      <DrawerAppBar
        onBack={() => {
          navigate("/mobile/separation/items");
        }}
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <Paper>
          <Stack spacing={4} sx={{ padding: "20px" }}>
            {reservation?.inventory.position && (
              <Typography fontWeight="bold" fontSize={"26px"}>
                {" "}
                {`${reservation?.inventory.position?.street}.${reservation?.inventory.position?.building}.${reservation?.inventory.position?.level}.${reservation?.inventory.position?.apartment}`}
              </Typography>
            )}
            <Stack direction="row">
              <TextField
                id="outlined-basic"
                label="Código da Posição"
                variant="outlined"
                sx={{
                  mx: "5px",
                }}
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
              />
              <Button
                variant="outlined"
                color="inherit"
                sx={{
                  mx: "5px",
                }}
              >
                <QrCodeIcon />
              </Button>
            </Stack>
          </Stack>
        </Paper>

        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={handleClick}
        >
          Confirmar
        </Button>
      </Stack>
    </>
  );
};
